import { useMemo } from 'react';
import { u as useBreakpoint } from './useBreakpoint-7QkBkSeP-CfR8YWax.js';
import { p as primitive } from './primitive-DEjVLxOV.js';

const sizeToToken = (value) => {
  if (typeof value === "undefined") return void 0;
  let gap = value;
  const stringifiedValue = String(value);
  if (stringifiedValue === "half") {
    gap = `${stringifiedValue[0].toUpperCase()}${stringifiedValue.slice(1)}`;
  }
  return primitive?.[`Size${gap}`]?.value;
};

const LAYOUT_PROP_ARR = [
  "gridTemplateColumns",
  "gridTemplateRows",
  "gridTemplateAreas",
  "gridAutoColumns",
  "gridAutoRows",
  "gridArea",
  "gridColumn",
  "gridRow",
  "gridColumnStart",
  "gridColumnEnd",
  "gridRowStart",
  "gridRowEnd",
  "flex",
  "flexDirection",
  "flexGrow",
  "flexShrink",
  "flexBasis",
  "flexWrap",
  "order",
  "justifySelf",
  "justifyItems",
  "justifyContent",
  "alignSelf",
  "alignItems",
  "alignContent",
  "placeItems",
  "placeContent",
  "placeSelf",
  "wrap",
  "gap",
  "rowGap",
  "columnGap"
];
const RESPONSIVE_SIZES_ARR = ["xs", "sm", "md", "lg", "xl", "xxl"];
function useLayoutPropsUtil(props) {
  const baseSizeProps = Object.fromEntries(
    Object.entries(props).filter(([key, val]) => LAYOUT_PROP_ARR.includes(key))
  );
  const responsiveSizeProps = Object.fromEntries(
    Object.entries(props).filter(
      ([key, val]) => RESPONSIVE_SIZES_ARR.includes(key)
    )
  );
  const sizeProps = useMemo(
    () => ({
      ...responsiveSizeProps,
      base: baseSizeProps
    }),
    [baseSizeProps, responsiveSizeProps]
  );
  const componentProps = Object.fromEntries(
    Object.entries(props).filter(
      ([key, val]) => !RESPONSIVE_SIZES_ARR.includes(key) && !LAYOUT_PROP_ARR.includes(key)
    )
  );
  const breakpoint = useBreakpoint();
  const getValue = (style) => {
    if (breakpoint?.name === "xxl") {
      const xxlValue = sizeProps.xxl?.[style] ?? sizeProps.xl?.[style] ?? sizeProps.lg?.[style] ?? sizeProps.md?.[style] ?? sizeProps.sm?.[style] ?? sizeProps.xs?.[style] ?? sizeProps.base?.[style];
      if (style.toLowerCase().endsWith("gap")) {
        return sizeToToken(xxlValue);
      }
      return xxlValue;
    }
    if (breakpoint?.name === "xl") {
      const xlValue = sizeProps.xl?.[style] ?? sizeProps.lg?.[style] ?? sizeProps.md?.[style] ?? sizeProps.sm?.[style] ?? sizeProps.xs?.[style] ?? sizeProps.base?.[style];
      if (style.toLowerCase().endsWith("gap")) {
        return sizeToToken(xlValue);
      }
      return xlValue;
    }
    if (breakpoint?.name === "lg") {
      const lgValue = sizeProps.lg?.[style] ?? sizeProps.md?.[style] ?? sizeProps.sm?.[style] ?? sizeProps.xs?.[style] ?? sizeProps.base?.[style];
      if (style.toLowerCase().endsWith("gap")) {
        return sizeToToken(lgValue);
      }
      return lgValue;
    }
    if (breakpoint?.name === "md") {
      const mdValue = sizeProps.md?.[style] ?? sizeProps.sm?.[style] ?? sizeProps.xs?.[style] ?? sizeProps.base?.[style];
      if (style.toLowerCase().endsWith("gap")) {
        return sizeToToken(mdValue);
      }
      return mdValue;
    }
    if (breakpoint?.name === "sm") {
      const smValue = sizeProps.sm?.[style] ?? sizeProps.xs?.[style] ?? sizeProps.base?.[style];
      if (style.toLowerCase().endsWith("gap")) {
        return sizeToToken(smValue);
      }
      return smValue;
    }
    if (breakpoint?.name === "xs") {
      const xsValue = sizeProps.xs?.[style] ?? sizeProps.base?.[style];
      if (style.toLowerCase().endsWith("gap")) {
        return sizeToToken(xsValue);
      }
      return xsValue;
    }
    if (style.toLowerCase().endsWith("gap")) {
      return sizeToToken(sizeProps.base?.[style]);
    }
    return sizeProps.base?.[style];
  };
  const layoutStyleObject = LAYOUT_PROP_ARR.reduce((o, key) => {
    const value = getValue(key);
    if (typeof value === "undefined") return o;
    return { ...o, [key]: value };
  }, {});
  return {
    layoutStyles: layoutStyleObject,
    componentProps
  };
}

export { sizeToToken as s, useLayoutPropsUtil as u };
//# sourceMappingURL=useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js.map
